import { render, staticRenderFns } from "./monitior1.vue?vue&type=template&id=68d8f6b5&scoped=true"
import script from "./monitior1.vue?vue&type=script&lang=js"
export * from "./monitior1.vue?vue&type=script&lang=js"
import style0 from "./monitior1.vue?vue&type=style&index=0&id=68d8f6b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d8f6b5",
  null
  
)

export default component.exports